import type { FC } from 'react'

import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'

import queries from '@/api/queries'
import systemMessagesResources from '@/api/system-messages'
import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import { appRoutes } from '@/util/misc'

import SystemMessage from './SystemMessage'

import './system-messages.scss'

const SystemMessageList: FC<{
  seenMessages?: number[]
  onSeenMessagesSet: (v: number[]) => void
  onBarClose: () => void
}> = ({ seenMessages, onSeenMessagesSet, onBarClose }) => {
  const { locale } = useAppContext()

  const { data } = useQuery(queries.systemMessages(), systemMessagesResources.getList)

  const messageList = data?.filter(message => message.locale === locale) || []

  if (!data || messageList.length === 0) return null

  const displayedMessage = messageList[0]

  return (
    <div className="system-messages">
      <h3 className="title">
        <Translation id="Notifications" />
      </h3>

      <div className="divider" />

      <div>
        <SystemMessage
          {...displayedMessage}
          seenMessages={seenMessages}
          onSeenMessagesSet={onSeenMessagesSet}
        />

        <div className="see-all-messages">
          <Link to={appRoutes.systemMessages} onClick={onBarClose}>
            <Translation id="See all notifications" className="lower-case" />
          </Link>
        </div>

        <div className="divider" />
      </div>
    </div>
  )
}

export default SystemMessageList
